// Admin dropdowns — vanilla JS, Turbo-compatible
// Handles all .admin-menu-dropdown elements generically.

function closeAdminDropdown(trigger, panel) {
  if (panel) panel.classList.remove("open");
  if (trigger) trigger.setAttribute("aria-expanded", "false");
}

function openAdminDropdown(trigger, panel) {
  // Close all other open dropdowns first
  document.querySelectorAll(".admin-menu-dropdown-menu.open").forEach(function (p) {
    if (p !== panel) {
      p.classList.remove("open");
      const t = document.querySelector('[aria-controls="' + p.id + '"], [data-panel="' + p.id + '"]');
      if (t) t.setAttribute("aria-expanded", "false");
    }
  });
  if (panel) panel.classList.add("open");
  if (trigger) trigger.setAttribute("aria-expanded", "true");
}

document.addEventListener("click", function (e) {
  document.querySelectorAll(".admin-menu-dropdown-menu.open").forEach(function (panel) {
    const wrapper = panel.closest(".admin-menu-dropdown");
    if (wrapper && !wrapper.contains(e.target)) {
      const trigger = wrapper.querySelector(".admin-menu-dropdown-trigger");
      closeAdminDropdown(trigger, panel);
    }
  });
});

document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    document.querySelectorAll(".admin-menu-dropdown-menu.open").forEach(function (panel) {
      const wrapper = panel.closest(".admin-menu-dropdown");
      const trigger = wrapper && wrapper.querySelector(".admin-menu-dropdown-trigger");
      closeAdminDropdown(trigger, panel);
    });
  }
});

document.addEventListener("turbo:before-cache", function () {
  document.querySelectorAll(".admin-menu-dropdown-menu.open").forEach(function (panel) {
    const wrapper = panel.closest(".admin-menu-dropdown");
    const trigger = wrapper && wrapper.querySelector(".admin-menu-dropdown-trigger");
    closeAdminDropdown(trigger, panel);
  });
});

function initAdminDropdowns() {
  document.querySelectorAll(".admin-menu-dropdown-trigger").forEach(function (trigger) {
    if (trigger.dataset.menuInitialized) return;
    trigger.dataset.menuInitialized = "true";

    // Find sibling panel: next .admin-menu-dropdown-menu inside the same wrapper
    const wrapper = trigger.closest(".admin-menu-dropdown");
    const panel = wrapper && wrapper.querySelector(".admin-menu-dropdown-menu");
    if (!panel) return;

    trigger.addEventListener("click", function (e) {
      e.stopPropagation();
      if (panel.classList.contains("open")) {
        closeAdminDropdown(trigger, panel);
      } else {
        openAdminDropdown(trigger, panel);
      }
    });
  });
}

document.addEventListener("turbo:load", initAdminDropdowns);
document.addEventListener("DOMContentLoaded", initAdminDropdowns);
